
















import Vue from 'vue';

export default Vue.extend({
  name: 'GNotifications',
  computed: {
    notifications() {
      return this.$stores.notifications.state.notifications;
    },
  },
  methods: {
    onClickNotifications(id: string) {
      return () => { this.$stores.notifications.removeNotificationItem(id); };
    },
    onNotificationTimeout(id: string) {
      this.$stores.notifications.removeNotificationItem(id);
    },
  },
});
